<div class="category-wrapper">
  <div class="category" [class]="AlertType[type!]">
    {{ type | alertsType }}
  </div>
</div>
